import { ThemeProvider } from "@emotion/react";
import * as React from "react";

import thumbsUp from "assets/svg/thumbs-up.svg";
import { legacyTheme } from "themes/legacyTheme";

import { Container, Header, Headline, StepImage, Wrapper } from "./styled";

const TicketRatingThankYou: React.FC = () => (
  <ThemeProvider theme={legacyTheme}>
    <Container>
      <Wrapper>
        <StepImage src={thumbsUp} />
        <Header>Thank you for your feedback!</Header>
        <Headline>This will help us improve our service.</Headline>
      </Wrapper>
    </Container>
  </ThemeProvider>
);

export default TicketRatingThankYou;
